import {
  subscribeToCompanyCreating,
  subscribeToCompanyDeleting,
  subscribeToCompanyUpdating,
  subscribeToAccountCreating,
  subscribeToAccountDeleting,
  subscribeToAccountUpdating,
  subscribeToEquipmentCreating,
  subscribeToEquipmentDeleting,
  subscribeToEquipmentUpdating,
  subscribeToPersonCreating,
  subscribeToPersonDeleting,
  subscribeToPersonUpdating,
  subscribeToVehicleCreating,
  subscribeToVehicleDeleting,
  subscribeToVehicleReservationCreating,
  subscribeToVehicleReservationDeleting,
  subscribeToVehicleReservationUpdating,
  subscribeToVehicleTypeCreating,
  subscribeToVehicleTypeDeleting,
  subscribeToVehicleTypeUpdating,
  subscribeToVehicleUpdating,
  subscribeToVehicleCounters,
} from './subscriptions';
import { subscribeToChatCreating, subscribeToChatDeleting, subscribeToChatUpdating } from './subscriptions/chat';
import {
  subscribeToChatMessageCreating,
  subscribeToChatMessageDeleting,
  subscribeToChatMessageUpdating,
  subscribeToLastReadMessageUpdating,
  subscribeToTotalUnreadMessagesCountUpdating,
} from './subscriptions/chat-message';

export const createStreamListener = () => {
  subscribeToCompanyCreating();
  subscribeToCompanyUpdating();
  subscribeToCompanyDeleting();

  subscribeToAccountCreating();
  subscribeToAccountUpdating();
  subscribeToAccountDeleting();

  subscribeToPersonCreating();
  subscribeToPersonUpdating();
  subscribeToPersonDeleting();

  subscribeToEquipmentCreating();
  subscribeToEquipmentUpdating();
  subscribeToEquipmentDeleting();

  subscribeToVehicleTypeCreating();
  subscribeToVehicleTypeUpdating();
  subscribeToVehicleTypeDeleting();

  subscribeToVehicleCreating();
  subscribeToVehicleUpdating();
  subscribeToVehicleDeleting();
  subscribeToVehicleCounters();

  subscribeToVehicleReservationCreating();
  subscribeToVehicleReservationUpdating();
  subscribeToVehicleReservationDeleting();

  subscribeToChatCreating();
  subscribeToChatUpdating();
  subscribeToChatDeleting();

  subscribeToChatMessageCreating();
  subscribeToChatMessageUpdating();
  subscribeToChatMessageDeleting();
  subscribeToLastReadMessageUpdating();
  subscribeToTotalUnreadMessagesCountUpdating();
};
